import { Icon } from '@iconify/react'
import locationIcon from '@iconify/icons-mdi/location'

const LocationMarkerBusinessDetail = () => {
    return (
        <div className="location-marker">
            <Icon icon={locationIcon} className="location-icon" />
        </div>
    )
}

export default LocationMarkerBusinessDetail
